module.exports = __webpack_public_path__ + "article-7051a3ee/lebenslauf-unterschreiben-11b4deff358b978f6fcb9743918f5d17.jpg";